import { useState } from "react";
import { Api } from "../api/Api";
import {useErrorWebhook} from "./useErrorWebhook";

export const useDataIngestion = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { ErrorWebhookTrigger } = useErrorWebhook();
  const saveDataIngestion = async (
    visitor_parameters,
    data,
    message_type,
    page_name,
    query_string,
    visitor_data
  ) => {
    setIsLoading(true);
    
    if (message_type === "split_page_load") {
      try {
        const { getBrowserCookie,getPidFromUrl } = await import('../Utility/Helper');

        let fbp = getBrowserCookie('_fbp') || "";
        let fbc = getBrowserCookie('_fbc') || "";
       
        data.fbpId = fbp;
        data.fbcId = fbc;
        data.fb_pid = getPidFromUrl();
      
      } catch (error) {
        console.error("Error getting 'pid,fbpid,fbcId' from URL:", error);
      }
    
    }

    const response = await Api.post("api/v1/data-ingestion-pipeline", {
      visitor_parameters,
      data,
      message_type,
      page_name,
      query_string,
      visitor_data,
    }).catch(function (error) {
      const erroMessage = {
        serviceName : 'Data Ingestion : '+message_type,
        errorReason:error.message,
        errorCode:error.code,
        uuid:visitor_parameters.uuid
      }
      ErrorWebhookTrigger(erroMessage);
    });
    setIsLoading(false);
    return response;
  };


  const formDataIngestion = async(
    visitor_parameters,
    data,
    message_type,
    page_name,
    query_string,
    visitor_data,
    pid = ""
  ) => {
    setIsLoading(true);

     if (message_type === "split_form_submit" ) {

      try {
        const { getBrowserCookie } = await import('../Utility/Helper');

        let fbp = getBrowserCookie('_fbp') || "";
        let fbc = getBrowserCookie('_fbc') || "";
       
        visitor_data.fbpId = fbp;
        visitor_data.fbcId = fbc;
        visitor_data.pid = pid;
      
      } catch (error) {
        console.error("Error getting 'pid,fbpid,fbcId' from URL:", error);
      }
    
    }  
    
    const response = Api.post("api/v1/data-ingestion-pipeline", {
      visitor_parameters,
      data,
      message_type,
      page_name,
      query_string,
      visitor_data,
    }).catch(function (error) {
      const erroMessage = {
        serviceName : 'Data Ingestion : '+message_type,
        errorReason:error.message,
        errorCode:error.code,
        uuid:visitor_parameters.uuid
      }
      ErrorWebhookTrigger(erroMessage);
    });
    setIsLoading(false);
    return response;
  };
  return { saveDataIngestion, formDataIngestion, isLoading };
};
